import React, {useState} from 'react';

type InterestItemProps = {
  text: string;
  isSelected?: boolean;
  onSelect: () => void;
};

export const InterestItem: React.FC<InterestItemProps> = ({
  text,
  isSelected = false,
  onSelect,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const containerStyle: React.CSSProperties = {
    padding: '12px 18px',
    borderRadius: '30px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s ease',
    fontSize: '0.9rem',
    fontWeight: 600,
    userSelect: 'none',
    backgroundColor: isSelected ? '#daff00' : 'transparent',
    color: isSelected ? '#000' : isHovered ? '#daff00' : '#fff',
    border: `1px solid ${isSelected || isHovered ? '#daff00' : '#555'}`,
    transform: isHovered ? 'translateY(-2px)' : 'translateY(0)',
    minWidth: '100px',
  };

  return (
    <div
      onClick={onSelect}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={containerStyle}>
      {text}
    </div>
  );
};
